<template>
  <nav class="navbar navbar-default navbar-static-top" :style="topBannerColor">
    <div class="container-fluid" role="banner">
      <div class="navbar-header">
        <button
          type="button"
          class="navbar-toggle collapsed"
          data-toggle="collapse"
          data-target="#navbar"
          aria-expanded="false"
          aria-controls="navbar"
        >
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <a class="navbar-brand p-5" href="#">
          <img ref="logo" @error="changeSrc" class="logo" :src="logoPath" alt="CapsimInbox™ Logo" />
        </a>
      </div>
      <div id="navbar" class="navbar-collapse collapse">
        <div v-if="!hideTimer && !isStateLoading" class="navbar-nav timer">
          <template v-if="!showTimerAsClock">
            <span class="mr-10">Time Remaining</span>
            <span
              :class="[{ 'hide-time': !showTimer }, clockColor, $store.state.time.timerClass]"
              class="time mr-10"
            >
              {{ parsedTime }}
            </span>
            <time-switch
              :selected="showTimer"
              theme="default"
              color="blue"
              @click="showTimer = !showTimer"
              label="<span class='sr-only'>showHide</span>"
            ></time-switch>
            <span class="ml-10">Show/Hide</span>
          </template>
          <template v-else>
            <span
              :class="[{ 'hide-time': !showTimer }, clockColor, $store.state.time.timerClass]"
              class="time mr-10"
            >
              {{ parsedTimeClock }}
            </span>
          </template>
        </div>

        <ul
          v-if="$store.state.assessmentTypeKey !== constants.ASSESSMENT_TYPE_KEY.PREVIEW"
          class="nav navbar-nav navbar-right flex align-center"
        >
          <li v-if="versionTemplateKey == 2" style="color: #fff">
            Name: <strong>{{ userData.firstname }} {{ userData.lastname }}</strong>
          </li>
          <li>
            <a
              v-if="$store.state.assessmentTypeKey != 4"
              @click="completeAssessment"
              class="mr-15 ml-15 btn exit-inbox navbar-btn btn-danger-outline"
              href="#"
            >
              <template v-if="versionTemplateKey == 2"> Submit Exam </template>
              <template v-else-if="$store.state.assessmentTypeKey == 1">
                {{ info.exit }}
              </template>
              <template v-else> Exit Inbox</template>
            </a>
            <a
              v-if="$store.state.assessmentTypeKey == 4"
              class="mr-15 ml-15 btn exit-inbox navbar-btn btn-danger-outline disabled"
              >Exit Inbox</a
            >
          </li>
        </ul>
      </div>
      <!--/.nav-collapse -->
    </div>
  </nav>
</template>

<script>
  import timeSwitch from './inputs/switch.vue';
  import { mapGetters, mapState } from 'vuex';

  const parseNumToString = (num) => (num < 10 ? '0' + num : `${num}`);

  export default {
    props: {
      themeData: {
        type: Object,
        required: false,
        default: {},
      },
    },
    data() {
      return {
        showTimer: true,
        clockColor: '',
        initial: true,
      };
    },
    components: {
      timeSwitch,
    },

    watch: {
      timer(val) {
        if (val <= 300000 && val > 60000) this.clockColor = 'five-minutes';
        else if (val < 60000) this.clockColor = 'one-minute';
      },
    },
    mounted() {
      EventBus.$on('displayTimer', () => (this.showTimer = !this.showTimer));
    },

    methods: {
      changeSrc() {
        this.$refs.logo.src = '/capsiminbox/images/CapsimInbox_Logo_White_withTM.jpg';
      },

      completeAssessment() {
        EventBus.$emit('completeAssessment', 'manualClickToExit');
      },
    },

    watch: {
      unreadMessages(value, oldValue) {
        let messagesLen = this.$store.getters['chat/activeMessages'].length;
        if (value === messagesLen && this.initial) return;
        if (oldValue < value) {
          this.initial = false;
        }
      },
    },

    computed: {
      ...mapState([
        'assetsPath',
        'versionKey',
        'userData',
        'info',
        'versionConfig',
        'versionTemplateKey',
        'simsettings',
        'isStateLoading',
      ]),
      ...mapGetters(['allowInboxSimReEntry']),
      ...mapGetters(['constants', 'showTimerAsClock']),
      ...mapGetters('email', ['unansweredEmails']),
      ...mapGetters('chat', ['activeMessages']),
      ...mapGetters('time', ['initialized', 'elapsed']),

      logoPath() {
        if (this.$store.state.userData.schoolKey === 11071) {
          return '/capsiminbox/images/lorman_light.png';
        }

        if (this.themeData.props && this.versionTemplateKey != 2) {
          return `${this.assetsPath}/capsiminbox/images/${this.themeData.props[4]}`;
        }

        return `${this.assetsPath}/capsiminbox/images/CapsimInbox_Logo_assessment_${this.versionKey}.png`;
      },

      topBannerColor() {
        if (
          this.themeData &&
          this.themeData.props !== undefined &&
          Object.keys(this.themeData.props).length
        ) {
          return { backgroundColor: this.themeData.props[1] };
        }
        return { backgroundColor: '#65757d' }; // to take care of modxm
      },

      unreadMessages() {
        if (this.unansweredEmails.length === 0)
          return this.activeMessages.filter((message) => !message.isRead).length;
        else
          return this.activeMessages.filter(
            (message) => message.timer <= this.elapsed && !message.isRead
          ).length;
      },

      colorTheme() {
        return `nav-theme-${this.versionTemplateKey}`;
      },

      timer() {
        return this.$store.state.time;
      },

      parsedPeriod: (vm) => (vm.timer.hour < 12 ? 'AM' : 'PM'),

      parsedTimeClock() {
        if (this.initialized) {
          const { hour, minutes } = this.timer;

          const timeStr = hour.toString() + ':' + minutes.toString();

          return this.$dayjs(timeStr, 'HH:mm').format('hh:mm A');
        } else {
          return '';
        }
      },

      parsedTime() {
        const parsedMin = this.timer.minutes <= 0 ? '00' : parseNumToString(this.timer.minutes);
        const parsedSec = this.timer.seconds <= 0 ? '00' : parseNumToString(this.timer.seconds);
        return parsedMin + ':' + parsedSec;
      },

      //this is mapped from version settings and hides the entire timer Div, including the showTimer toggle
      hideTimer() {
        let isNoTimerForNewInbox = false;
        if (this.simsettings !== undefined) {
          if (
            this.simsettings.assessment !== undefined &&
            this.simsettings.assessment.inboxTimeToComplete !== undefined
          ) {
            isNoTimerForNewInbox = this.simsettings.assessment.inboxTimeToComplete === 'noTimer';
          } else if (this.simsettings.exam !== undefined) {
            isNoTimerForNewInbox = this.simsettings.exam.data.inboxTimeToComplete === 'noTimer';
          }
        }
        // const isNoTimerForNewInbox =
        //   this.simsettings !== undefined &&
        //   this.simsettings.exam !== undefined &&
        //   this.simsettings.exam.data.inboxTimeToComplete === 'noTimer';

        return (this.versionConfig && this.versionConfig.hideTimer) || isNoTimerForNewInbox;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .nav-theme-2 {
    background-color: #1572d5 !important;
  }
  nav {
    margin-bottom: 0;
    border: none;

    .logo {
      height: 40px;
    }

    .navbar-right {
      .exit-inbox {
        background-color: #ffffff !important;
        color: black !important;
        line-height: 5px;
        border-color: #c20611;
        border-width: 1px;

        &:hover,
        &:focus {
          background-color: #c20611 !important;
          color: white !important;
        }
      }
    }

    .navbar-collapse {
      text-align: center;
    }

    ul {
      li {
        a {
          color: white !important;
          font-size: 18px;
          &:hover {
            -webkit-transition: all 350ms cubic-bezier(0.19, 1, 0.22, 1);
            transition: all 350ms cubic-bezier(0.19, 1, 0.22, 1);
            background-color: rgba(255, 255, 255, 0.15) !important;
          }
        }
      }
    }

    .unread-messages {
      position: absolute;
      bottom: 15px;
      right: 0px;
      background-color: #df0816;
      border-radius: 15px;
      width: 20px;
      height: 15px;
      line-height: 15px;
      font-size: 10px;
    }

    // .btn-modx-exit{
    //     background-color: #CFCFCF;
    //     border-color: #474747;
    //     color: #000000;
    // }
    // .btn-modx-exit:hover{
    //     background-color: #AFAFAF;
    //     border-color: #272727;
    // }

    .timer {
      line-height: 50px;
      color: white;
      display: inline-block;
      float: none;

      .time {
        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);
        background-color: white;
        border-radius: 2px;
        padding: 8px;
        width: 30px;
        color: black;
        &.hide-time {
          color: white;
        }
        &.five-minutes {
          background-color: yellow;
        }
        &.one-minute {
          background-color: #df0816;
          color: white;
        }
        &.timeImpactEffect {
          -webkit-animation: timeImpactFlash linear 1s;
          animation: timeImpactFlash linear 1s;
        }
        @-webkit-keyframes timeImpactFlash {
          0% {
            background-color: #23bd40;
          }
          100% {
            background-color: #fff;
          }
        }

        @keyframes timeImpactFlash {
          0% {
            background-color: #23bd40;
          }
          100% {
            background-color: #fff;
          }
        }
      }
    }
  }
</style>
